import styled from "styled-components"
import { CalendarEvent } from "./AdRecruitCalendar"
import { CommonButton, NextButton } from "../common/CommonStyled"
import { useEffect } from "react"
import { useModalStore } from "src/stores/ModalStore"
import { ModalContent_ModalRecruitCalendarDetail, ModalTitle_ModalRecruitCalendarDetail } from "./ModalRecruitCalendarDetail"
import { deleteAnncouncement } from "src/api/Admin"
import { useFetchRecruitSchedule } from "./useLoadRecruitSchedule"

const Title_PageWrapper = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;

    position: relative;
    font-size: 24px;
    font-weight: 600;
    margin-bottom: 20px;
`

interface ModalTitle_Props{
    item : CalendarEvent
}

export const ModalTitle_RecruitCalendarDelete = ({item}:ModalTitle_Props)=>{
    const modalSetField = useModalStore((state)=>state.setField)
    const temporalState = useModalStore((state)=>state.temporalState)
    useEffect(()=>{
        modalSetField('width','466px')
        modalSetField('padding','32px')
    },[])
    return(
        <Title_PageWrapper>
            {temporalState ? '삭제되었습니다.':`${item.title} 일정을 삭제하시겠습니까?`}
        </Title_PageWrapper>
    )
}

const Content_PageWrapper = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;

    position: relative;
    /* font-size: 16px; */
    /* font-weight: 600; */
    margin-bottom: 20px;
`

export const ModalContent_RecruitCalendarDelete = ()=>{
    return(
        <Content_PageWrapper>
            삭제 후에는 복구가 불가합니다.
        </Content_PageWrapper>
    )
}

const ButtonWrapper = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 16px;

    height: 40px;
    /* position: absolute; */
    width: 152px;
    margin-left: auto;
`
export const ModalFooter_RecruitCalendarDelete = ({item}:ModalTitle_Props)=>{
    const modalSetField = useModalStore((state)=>state.setField)
    const reset = useModalStore((state)=>state.reset)
    const temporalState = useModalStore((state)=>state.temporalState)
    const { fetchData } = useFetchRecruitSchedule();
    const onClickCancle = ()=>{
        modalSetField('title',<ModalTitle_ModalRecruitCalendarDetail item={item}/>)
        modalSetField('content',<ModalContent_ModalRecruitCalendarDetail item={item}/>)
        modalSetField('footer',<></>)
    }
    const onClickDelete = async ()=>{
        if(temporalState){
            modalSetField('open',false)
        }
        else{
            await deleteAnncouncement(item.announce_id)
            modalSetField('content',<></>)
            modalSetField('temporalState',true)
            fetchData()
        }
    }
    useEffect(()=>{
        return()=>{
            reset()
        }
    },[])
    return(
        <ButtonWrapper style={{width: temporalState ? '68px':'152px'}}>
            {!temporalState &&
            <CommonButton style={{padding:'12px 20px', backgroundColor:'#E3E3E3', border:'1px solid black', borderRadius:'8px', color:'black'}} onClick={onClickCancle}>취소</CommonButton>
            }
            <NextButton style={{padding:'12px 20px'}} onClick={onClickDelete}>확인</NextButton>
        </ButtonWrapper>
    )
}